import { Link } from 'react-router-dom';
import { FaWhatsapp, FaInstagram, FaTiktok } from 'react-icons/fa';
import { HiOutlineClipboardList } from 'react-icons/hi';
import '../styles/FloatingButtons.css';

const WHATSAPP_URL = 'https://wa.me/573215320525';
const INSTAGRAM_URL = 'https://www.instagram.com/official_tmodels?igsh=ZnpsdjFrbGczNnZt';
const TIKTOK_URL = 'https://www.tiktok.com/@tmodels.co?_r=1&_t=ZS-93U9h14ek0w';

function FloatingButtons() {
  return (
    <aside className="tm-floating-buttons" aria-label="Accesos rápidos">
      <span className="tm-floating-btn-wave-wrap">
        <Link
          to="/registro"
          className="tm-floating-btn tm-floating-btn-contact"
          aria-label="Formulario de registro"
          title="Formulario"
        >
          <HiOutlineClipboardList className="tm-floating-btn-icon" />
        </Link>
      </span>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="tm-floating-btn tm-floating-btn-whatsapp"
        aria-label="WhatsApp"
        title="WhatsApp"
      >
        <FaWhatsapp className="tm-floating-btn-icon" />
      </a>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="tm-floating-btn tm-floating-btn-instagram"
        aria-label="Instagram"
        title="Instagram"
      >
        <FaInstagram className="tm-floating-btn-icon" />
      </a>
      <a
        href={TIKTOK_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="tm-floating-btn tm-floating-btn-tiktok"
        aria-label="TikTok"
        title="TikTok"
      >
        <FaTiktok className="tm-floating-btn-icon" />
      </a>
    </aside>
  );
}

export default FloatingButtons;
